/**
 * The end of the run: the last maze crossed, and nothing left to walk into.
 *
 * The pause dialog's sibling by design — same modal, same focus trap, same one button —
 * because the player has learned that dialog already and the end of a run is not the place
 * to teach them a new one. What differs is that there is nothing behind it to go back to:
 * the only action is to run it again.
 */

import { useRef } from 'react';
import { useFocusTrap } from './useFocusTrap';
import { useGameStore } from '../store/gameStore';

export function CompletionOverlay() {
  const dialogRef = useRef<HTMLDivElement>(null);
  useFocusTrap(dialogRef);
  const restart = useGameStore((store) => store.restart);

  return (
    <div className="overlay">
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="complete-heading"
        className="overlay"
        style={{ position: 'static', background: 'transparent', padding: 0 }}
      >
        <h2 id="complete-heading">Out of the maze</h2>
        <p>You found your way through all three. That is the whole labyrinth.</p>
        <button type="button" className="button" onClick={() => restart()}>
          Play again
        </button>
      </div>
    </div>
  );
}
